import React, { useState } from 'react';
import { EditIcon, ShowIcon } from '@/utils/svgs';
import FormModal from '@/components/modals/FormModal';
import ChangesAlert from '@/components/alert/ChangesAlert';
import PreviewQuoteTemplate from '@/pages/events/models/previewQutoeTemplate/PreviewQuoteTemplate';
import StageDropdown from '@/components/stageDropdown/StageDropdown';
import SearchSelect from '@/components/StyledSelect/SearchSelect';
import viewIcon from '@/assets/icons/viewIcon.svg';
import editIcon from '@/assets/icons/editIcon.svg';
import deleteIcon from '@/assets/icons/deleteIcon.svg';
import { useNavigate } from 'react-router-dom';
import { Loader } from '@thdinc/hpf-shared';
import { IQuoteObject } from '@/interfaces';
import { centsToDollors, formattedDate } from '@/helpers/TimeFormat';
import { API_ROUTES } from '@/services/environment';
import { DELETE, PATCH } from '@/services/api';
import { fmt } from '@/helpers/quoteFunctions';

const EventListTable: React.FC<{
    rowsData: IQuoteObject[];
    quotesLoading: boolean;
    refetch: () => void;
    currBusiness: any;
}> = ({ rowsData, quotesLoading, currBusiness, refetch }) => {
    const [viewDetailModalOpen, setViewDetailModalOpen] = useState(false);
    const [selectedStages, setSelectedStages] = useState<Record<string, string>>({});
    const [isLinkLoading, setIsLinkLoading] = useState(false);
    const [selectedQuote, setSelectedQuote] = useState<any>();
    const [quoteToDelete, setQuoteToDelete] = useState<IQuoteObject | null>(null);
    const [deletingQuoteId, setDeletingQuoteId] = useState<string | null>(null);
    const navigate = useNavigate();
    const closeCardModal = () => {
        setIsLinkLoading(false);
        setViewDetailModalOpen(false);
    };

    const tableHeaders = [
        'Event Date',
        'Request Date',
        'Name',
        'Amount',
        'Alcohol Amount',
        'Stage',
        'Type',
        'Actions',
    ];

    const updateQuoteStage = async (id: string, stage: string) => {
        console.log('This is hsiofhsahfi => ', id, stage);
        try {
            await PATCH(`${API_ROUTES.quoteStage}/${id}`, { quote_stage: stage });
            refetch();
        } catch (error) {
            console.log('error----:', error);
        }
    };
    const stageName = (item: any) => {
        const stage = selectedStages[item.id] ?? item.quote_stage;
        if (stage === 'inquiry') return 'lead';
        if (stage === 'manually-booked') return 'Manually Booked';
        return stage;
    }

    const deleteQuote = async (id: string) => {
        try {
            setDeletingQuoteId(id);
            await DELETE(`${API_ROUTES.deleteQuoteById}/${id}`);
            setViewDetailModalOpen(false);
            refetch();
        } catch (error) {
            console.log('error deleting quote----:', error);
        } finally {
            setDeletingQuoteId(null);
            setQuoteToDelete(null);
        }
    };
    return (
        <div className='relative overflow-x-auto rounded-lg mt-4 overflow-y-auto max-h-[700px]'>
            <table className='w-full text-xs sm:text-sm bg-white text-gray-500 rounded-t-xl overflow-hidden border'>
                <thead className='text-[10px] sm:text-xs text-gray-700 bg-white uppercase border-b'>
                    <tr>
                        {tableHeaders.map((data: string, index) => {
                            return (
                                <th
                                    key={index}
                                    scope='col'
                                    className={`px-2 py-2 sm:px-4 sm:py-3 font-semibold ${index === 0
                                        ? `text-left`
                                        : index === tableHeaders.length - 1
                                            ? `text-right`
                                            : `text-center`
                                        } `}
                                >
                                    {data}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {quotesLoading ? (
                        <td colSpan={8}>
                            <div className='mt-3 mb-3'>
                                <Loader color='bg-red-500' classes='mt-2' />
                            </div>
                        </td>
                    ) : (
                        rowsData.map((item, idx) => (
                            <tr key={idx} className='bg-white border-b  text-[11px] sm:text-sm'>
                                <td className='px-2 py-2 sm:px-4 sm:py-3 text-left text-[#202224]'>
                                    {formattedDate(item.start_time)}
                                </td>
                                <td className='px-2 py-2 sm:px-4 sm:py-3 text-center text-[#202224]'>
                                    {formattedDate(item.created_at)}
                                </td>
                                <td className='px-2 py-2 sm:px-4 sm:py-3 text-center text-[#202224]'>
                                    {item.first_name} {item.last_name}
                                </td>
                                <td className='px-2 py-2 sm:px-4 sm:py-3 text-center text-[#202224]'>
                                    {item.discount_applied ? fmt(centsToDollors(item.bartender_package_total - item.discount_total)) : fmt(centsToDollors(item.bartender_package_total))}
                                </td>
                                <td className='px-2 py-2 sm:px-4 sm:py-3 text-center text-[#202224]'>
                                    {/* {fmt(centsToDollors(item.estimated_alcohol_total))} */}
                                    {fmt(centsToDollors(item.estimated_alcohol_total ?? 0) + centsToDollors(item.estimated_alcohol_total ? item.estimated_alcohol_total * 0.10 : 0))}
                                </td>

                                {/* Stage Dropdown */}
                                <td className='px-2 py-2 sm:px-4 sm:py-3 text-center text-[#202224] flex justify-center'>
                                    <SearchSelect
                                        value={{
                                            name: stageName(item),

                                            value: (
                                                selectedStages[item.id] ?? item.quote_stage
                                            )?.toLowerCase(),
                                        }}
                                        onChange={(selected) => {
                                            setSelectedStages((prev) => ({
                                                ...prev,
                                                [item.id]: selected.value,
                                            }));

                                            updateQuoteStage(item.id, selected.value);
                                        }}
                                        options={[
                                            { name: 'Draft', value: 'draft' },
                                            // { name: 'Inquiry', value: 'inquiry' },
                                            { name: 'Proposed', value: 'proposed' },
                                            { name: 'Opened', value: 'opened' },
                                            { name: 'Archived', value: 'archived' },
                                            { name: 'Manually Booked', value: 'manually-booked' },
                                        ]}
                                        backgroundColor={
                                            (selectedStages[item.id] ?? item.quote_stage) === 'inquiry'
                                                ? '#FFEDD5'
                                                : '#f7f8fa'
                                        }
                                        data-testid='stage-select'
                                        placeholder='Select Stage'
                                    />
                                </td>

                                <td className='px-2 py-2 sm:px-4 sm:py-3 capitalize text-center text-[#202224]'>
                                    {item.quote_status}
                                </td>

                                <td className='px-2 py-2 sm:px-4 sm:py-3 text-right text-blue-600 font-medium cursor-pointer'>
                                    <div className='inline-flex justify-end items-center space-x-2'>
                                        <img
                                            onClick={() => {
                                                setSelectedQuote(item);
                                                setViewDetailModalOpen(true);
                                            }}
                                            className=' rounded-full bg-white hover:bg-gray-100 transition w-1/2 h-auto md:w-full'
                                            src={viewIcon} alt='Show Icon' />
                                        <img
                                            onClick={() =>
                                                navigate(`/quoteBuilder/${item.id}`, {
                                                    state: {
                                                        currBusiness: currBusiness,
                                                    },
                                                })
                                            }
                                            src={editIcon}
                                            alt='Edit Icon'
                                            className=' rounded-full bg-white hover:bg-gray-100 transition w-1/2 h-auto md:w-full'
                                        />
                                        {deletingQuoteId === item.id ? (
                                            <Loader color='bg-red-500' />
                                        ) : (
                                            <img
                                                onClick={() => setQuoteToDelete(item)}
                                                src={deleteIcon}
                                                alt='Delete Icon'
                                                className=' rounded-full bg-white hover:bg-gray-100 transition w-1/2 h-auto md:w-full'
                                            />
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            <FormModal
                isEditButton={viewDetailModalOpen}
                isDeleteButton={viewDetailModalOpen}
                overflow='overflow-hidden'
                modalTitle='Quote Preview'
                isOpen={viewDetailModalOpen}
                onClose={closeCardModal}
                onEditClick={() => {
                    if (!selectedQuote) return;
                    setViewDetailModalOpen(false);
                    navigate(`/quoteBuilder/${selectedQuote.id}`, {
                        state: { currBusiness: currBusiness },
                    });
                }}
                onDeleteClick={() => setQuoteToDelete(selectedQuote)}
                width='lg:w-3/6 md:w-5/6 w-full'
            >
                <PreviewQuoteTemplate
                    viewDetailModalOpen={viewDetailModalOpen}
                    setViewDetailModalOpen={setViewDetailModalOpen}
                    isTemplateOpen={true}
                    quote={selectedQuote}
                    updateQuoteStage={updateQuoteStage}
                />
            </FormModal>
            <ChangesAlert
                title='Delete Quote'
                desc={`Are you sure you want to delete the quote for "${quoteToDelete ? `${quoteToDelete.first_name} ${quoteToDelete.last_name}` : 'this quote'}"? This action cannot be undone.`}
                positiveButtonText='Delete'
                negativeButtonText='Cancel'
                isOpen={!!quoteToDelete}
                isLoading={deletingQuoteId === quoteToDelete?.id}
                handleSaveChanges={() => quoteToDelete && deleteQuote(quoteToDelete.id)}
                handleDiscardChanges={() => setQuoteToDelete(null)}
            />
        </div>
    );
};

export default EventListTable;
